var map = {
	"./lang.af.js": [
		"./src/editor/locale/lang.af.js",
		"src_editor_locale_lang_af_js"
	],
	"./lang.ar.js": [
		"./src/editor/locale/lang.ar.js",
		"src_editor_locale_lang_ar_js"
	],
	"./lang.az.js": [
		"./src/editor/locale/lang.az.js",
		"src_editor_locale_lang_az_js"
	],
	"./lang.be.js": [
		"./src/editor/locale/lang.be.js",
		"src_editor_locale_lang_be_js"
	],
	"./lang.bg.js": [
		"./src/editor/locale/lang.bg.js",
		"src_editor_locale_lang_bg_js"
	],
	"./lang.ca.js": [
		"./src/editor/locale/lang.ca.js",
		"src_editor_locale_lang_ca_js"
	],
	"./lang.cs.js": [
		"./src/editor/locale/lang.cs.js",
		"src_editor_locale_lang_cs_js"
	],
	"./lang.cy.js": [
		"./src/editor/locale/lang.cy.js",
		"src_editor_locale_lang_cy_js"
	],
	"./lang.da.js": [
		"./src/editor/locale/lang.da.js",
		"src_editor_locale_lang_da_js"
	],
	"./lang.de.js": [
		"./src/editor/locale/lang.de.js",
		"src_editor_locale_lang_de_js"
	],
	"./lang.el.js": [
		"./src/editor/locale/lang.el.js",
		"src_editor_locale_lang_el_js"
	],
	"./lang.en.js": [
		"./src/editor/locale/lang.en.js",
		"src_editor_locale_lang_en_js"
	],
	"./lang.es.js": [
		"./src/editor/locale/lang.es.js",
		"src_editor_locale_lang_es_js"
	],
	"./lang.et.js": [
		"./src/editor/locale/lang.et.js",
		"src_editor_locale_lang_et_js"
	],
	"./lang.fa.js": [
		"./src/editor/locale/lang.fa.js",
		"src_editor_locale_lang_fa_js"
	],
	"./lang.fi.js": [
		"./src/editor/locale/lang.fi.js",
		"src_editor_locale_lang_fi_js"
	],
	"./lang.fr.js": [
		"./src/editor/locale/lang.fr.js",
		"src_editor_locale_lang_fr_js"
	],
	"./lang.fy.js": [
		"./src/editor/locale/lang.fy.js",
		"src_editor_locale_lang_fy_js"
	],
	"./lang.ga.js": [
		"./src/editor/locale/lang.ga.js",
		"src_editor_locale_lang_ga_js"
	],
	"./lang.gl.js": [
		"./src/editor/locale/lang.gl.js",
		"src_editor_locale_lang_gl_js"
	],
	"./lang.he.js": [
		"./src/editor/locale/lang.he.js",
		"src_editor_locale_lang_he_js"
	],
	"./lang.hi.js": [
		"./src/editor/locale/lang.hi.js",
		"src_editor_locale_lang_hi_js"
	],
	"./lang.hr.js": [
		"./src/editor/locale/lang.hr.js",
		"src_editor_locale_lang_hr_js"
	],
	"./lang.hu.js": [
		"./src/editor/locale/lang.hu.js",
		"src_editor_locale_lang_hu_js"
	],
	"./lang.hy.js": [
		"./src/editor/locale/lang.hy.js",
		"src_editor_locale_lang_hy_js"
	],
	"./lang.id.js": [
		"./src/editor/locale/lang.id.js",
		"src_editor_locale_lang_id_js"
	],
	"./lang.is.js": [
		"./src/editor/locale/lang.is.js",
		"src_editor_locale_lang_is_js"
	],
	"./lang.it.js": [
		"./src/editor/locale/lang.it.js",
		"src_editor_locale_lang_it_js"
	],
	"./lang.ja.js": [
		"./src/editor/locale/lang.ja.js",
		"src_editor_locale_lang_ja_js"
	],
	"./lang.ko.js": [
		"./src/editor/locale/lang.ko.js",
		"src_editor_locale_lang_ko_js"
	],
	"./lang.lt.js": [
		"./src/editor/locale/lang.lt.js",
		"src_editor_locale_lang_lt_js"
	],
	"./lang.lv.js": [
		"./src/editor/locale/lang.lv.js",
		"src_editor_locale_lang_lv_js"
	],
	"./lang.mk.js": [
		"./src/editor/locale/lang.mk.js",
		"src_editor_locale_lang_mk_js"
	],
	"./lang.ms.js": [
		"./src/editor/locale/lang.ms.js",
		"src_editor_locale_lang_ms_js"
	],
	"./lang.mt.js": [
		"./src/editor/locale/lang.mt.js",
		"src_editor_locale_lang_mt_js"
	],
	"./lang.nl.js": [
		"./src/editor/locale/lang.nl.js",
		"src_editor_locale_lang_nl_js"
	],
	"./lang.no.js": [
		"./src/editor/locale/lang.no.js",
		"src_editor_locale_lang_no_js"
	],
	"./lang.pl.js": [
		"./src/editor/locale/lang.pl.js",
		"src_editor_locale_lang_pl_js"
	],
	"./lang.pt-BR.js": [
		"./src/editor/locale/lang.pt-BR.js",
		"src_editor_locale_lang_pt-BR_js"
	],
	"./lang.pt-PT.js": [
		"./src/editor/locale/lang.pt-PT.js",
		"src_editor_locale_lang_pt-PT_js"
	],
	"./lang.ro.js": [
		"./src/editor/locale/lang.ro.js",
		"src_editor_locale_lang_ro_js"
	],
	"./lang.ru.js": [
		"./src/editor/locale/lang.ru.js",
		"src_editor_locale_lang_ru_js"
	],
	"./lang.sk.js": [
		"./src/editor/locale/lang.sk.js",
		"src_editor_locale_lang_sk_js"
	],
	"./lang.sl.js": [
		"./src/editor/locale/lang.sl.js",
		"src_editor_locale_lang_sl_js"
	],
	"./lang.sq.js": [
		"./src/editor/locale/lang.sq.js",
		"src_editor_locale_lang_sq_js"
	],
	"./lang.sr.js": [
		"./src/editor/locale/lang.sr.js",
		"src_editor_locale_lang_sr_js"
	],
	"./lang.sv.js": [
		"./src/editor/locale/lang.sv.js",
		"src_editor_locale_lang_sv_js"
	],
	"./lang.sw.js": [
		"./src/editor/locale/lang.sw.js",
		"src_editor_locale_lang_sw_js"
	],
	"./lang.test.js": [
		"./src/editor/locale/lang.test.js",
		"src_editor_locale_lang_test_js"
	],
	"./lang.th.js": [
		"./src/editor/locale/lang.th.js",
		"src_editor_locale_lang_th_js"
	],
	"./lang.tl.js": [
		"./src/editor/locale/lang.tl.js",
		"src_editor_locale_lang_tl_js"
	],
	"./lang.tr.js": [
		"./src/editor/locale/lang.tr.js",
		"src_editor_locale_lang_tr_js"
	],
	"./lang.uk.js": [
		"./src/editor/locale/lang.uk.js",
		"src_editor_locale_lang_uk_js"
	],
	"./lang.vi.js": [
		"./src/editor/locale/lang.vi.js",
		"src_editor_locale_lang_vi_js"
	],
	"./lang.yi.js": [
		"./src/editor/locale/lang.yi.js",
		"src_editor_locale_lang_yi_js"
	],
	"./lang.zh-CN.js": [
		"./src/editor/locale/lang.zh-CN.js",
		"src_editor_locale_lang_zh-CN_js"
	],
	"./lang.zh-HK.js": [
		"./src/editor/locale/lang.zh-HK.js",
		"src_editor_locale_lang_zh-HK_js"
	],
	"./lang.zh-TW.js": [
		"./src/editor/locale/lang.zh-TW.js",
		"src_editor_locale_lang_zh-TW_js"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./src/editor/locale lazy recursive ^\\.\\/lang\\..*\\.js$";
module.exports = webpackAsyncContext;